import { ShieldCheck, Eye, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Replaced the previous "Real Trader Payouts" section (which showed
 * hardcoded, unsourced payout amounts marked "Verified") with a
 * transparent methodology section that explains how we verify data.
 */
export const PayoutProof = () => {
  return (
    <div>
      <div className="mb-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
          How We Verify Data
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mt-2 max-w-2xl mx-auto">
          Every firm listed on PinnacleBuy is manually checked against its official website. Here's our process.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-6 shadow-sm">
          <div className="flex items-center gap-2 mb-3">
            <div className="bg-emerald-100 dark:bg-emerald-900/30 p-2 rounded-lg">
              <ShieldCheck className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">Price Verification</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
            We check each firm's pricing page directly and record the base price, any active promo, and the coupon code. If we can't confirm a discount, we don't show one.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-6 shadow-sm">
          <div className="flex items-center gap-2 mb-3">
            <div className="bg-blue-100 dark:bg-blue-900/30 p-2 rounded-lg">
              <Eye className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">Rule Auditing</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
            Drawdown types, profit targets, consistency rules, and payout terms are sourced from official firm documentation. We flag when rules change.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-6 shadow-sm">
          <div className="flex items-center gap-2 mb-3">
            <div className="bg-amber-100 dark:bg-amber-900/30 p-2 rounded-lg">
              <RefreshCw className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white">Freshness Tracking</h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
            Each listing shows when it was last verified. Firms that haven't been rechecked recently are flagged so you know what's current.
          </p>
        </div>
      </div>

      <div className="text-center mt-6">
        <Link
          to="/methodology"
          className="text-sm text-brand-blue hover:text-brand-darkBlue font-medium"
        >
          Read our full methodology →
        </Link>
      </div>
    </div>
  );
};
